module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_5_4_2.4fae6252.jpeg";